// removed by extract-text-webpack-plugin
module.exports = {"usageMeter":"UsageMeter__usageMeter","bar":"UsageMeter__bar"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/UsageMeter/UsageMeter.scss
// module id = 1834
// module chunks = 8